import { render, staticRenderFns } from "./MDashboard.vue?vue&type=template&id=3491b2ca&scoped=true&"
import script from "./MDashboard.vue?vue&type=script&lang=ts&"
export * from "./MDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./MDashboard.vue?vue&type=style&index=0&id=3491b2ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491b2ca",
  null
  
)

export default component.exports